import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../../../components/MaterialBox";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialInput from "../../../../../../components/MaterialInput";
import { Box, FormControl, FormHelperText, Icon, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useUserDetails } from "../../../../../../context/auth";
import { BsEye } from "react-icons/bs";
const PFDetails = ({
  employeeData,
  handleEmployeeDataChange,
  handleFileChange,
  togglePage,
}) => {
  const { validationMessages } = useUserDetails();

  const [ifscDetails, setIfscDetails] = useState({
    bankName: "IOB",
    branchName: "Tirupur branch",
  });

  return (
    <MaterialBox>
      <MaterialTypography variant="h5">Banking info</MaterialTypography>
      <Grid container spacing={1}>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Account Number <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.123456789"
            name="accountnumber"
            value={employeeData.accountnumber}
            onChange={handleEmployeeDataChange}
            error={employeeData.accountnumberStatus === "error" ? true : false}
            success={
              employeeData.accountnumberStatus === "success" ? true : false
            }
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.accountnumberStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 35 digits
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.accountnumber && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.accountnumber}
            </label>
          )}
        </Grid>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Bank Name
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.ABCD"
            name="bankname"
            value={employeeData.bankname}
            onChange={handleEmployeeDataChange}
            error={employeeData.banknameStatus === "error" ? true : false}
            success={employeeData.banknameStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.banknameStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only Text Fields maximum of 25 Characters.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.bankname && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.bankname}
            </label>
          )}
        </Grid>
        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Enter IFSC
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.ABCD0000128"
            name="enterIfsc"
            value={employeeData.enterIfsc}
            onChange={handleEmployeeDataChange}
            error={employeeData.enterIfscStatus === "error" ? true : false}
            success={employeeData.enterIfscStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.enterIfscStatus === "error" ? (
            <FormControl error>
              <FormHelperText>
                Please enter a valid IFSC code Eg:HDFC0000189
              </FormHelperText>
            </FormControl>
          ) : null}
          {employeeData.isIfscVerifyStatus === "success" && (
            <FormControl>
              <FormHelperText>
                <MaterialTypography
                  variant="caption"
                  fontWeight="bold"
                  color="success"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CheckIcon />
                  &nbsp; Verified
                  <MaterialTypography
                    variant="caption"
                    fontWeight="bold"
                    color="success"
                    ml={2}
                  >
                    {ifscDetails?.bankName}, {ifscDetails?.branchName}
                  </MaterialTypography>
                </MaterialTypography>
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.enterIfsc && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.enterIfsc}
            </label>
          )}
        </Grid>

        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              CIF Number
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.123456789"
            name="cifnumber"
            value={employeeData.cifnumber}
            onChange={handleEmployeeDataChange}
            error={employeeData.cifnumberStatus === "error" ? true : false}
            success={employeeData.cifnumberStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.cifnumberStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only numbers maximum 25 digits
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.cifnumber && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.cifnumber}
            </label>
          )}
        </Grid>

        <Grid item size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Branch Name <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            type="text"
            placeholder="eg.CHENNAI"
            name="branchname"
            value={employeeData.branchname}
            onChange={handleEmployeeDataChange}
            error={employeeData.branchnameStatus === "error" ? true : false}
            success={employeeData.branchnameStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {employeeData.branchnameStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Should accept only Text Fields maximum of 25 Characters.
              </FormHelperText>
            </FormControl>
          )}
          {validationMessages.branchname && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.branchname}
            </label>
          )}
        </Grid>
        <Grid size={{ xs: 5, sm: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Bank Passbook
          </MaterialTypography>

          {employeeData?.bankPassbookImage && typeof employeeData.bankPassbookImage === "string" && (
            <a
              href={employeeData.bankPassbookImage}
              target="_blank"
              rel="noopener noreferrer"
              title="View"
              style={{ marginLeft: "8px", fontSize: "12px", color: "#1976d2" }}
            >
              <BsEye />
            </a>
          )}
        </MaterialBox>

        <Box
          sx={{
            border: "1.5px dashed #ccc",
            borderRadius: "6px",
            padding: "6px",
            textAlign: "center",
            cursor: togglePage.view ? "default" : "pointer",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            backgroundColor: togglePage.view ? "#f5f5f5" : "inherit",
            "&:hover": { borderColor: togglePage.view ? "#ccc" : "#1976d2" },
          }}
        >
          {!togglePage.view && (
            <input
              type="file"
              name="bankPassbook"
              title=""
              disabled={togglePage.view}
              onChange={(e) => handleFileChange(e, "bankPassbookImage")}
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                opacity: 0,
                cursor: "pointer",
              }}
            />
          )}

          <Box display="flex" alignItems="center" gap={1}>
            {employeeData?.bankPassbookImage && typeof employeeData.bankPassbookImage === "string" ? (
              employeeData.bankPassbookImage.endsWith(".pdf") ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  viewBox="0 0 24 24"
                  width="20"
                  fill="#d32f2f"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM13 9V3.5L18.5 9H13zm-2 9H8v-1.5h3.5V15H9v-1.5h2c.55 0 1 .45 1 1V18z" />
                </svg>
              ) : (
                <img
                  src={employeeData.bankPassbookImage}
                  alt="Bank Passbook"
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "3px",
                    objectFit: "cover",
                  }}
                />
              )
            ) : null}

            <Typography
              variant="caption"
              color="textSecondary"
              sx={{
                fontSize: "12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {employeeData?.bankPassbookImage
                ? typeof employeeData.bankPassbookImage === "string"
                  ? employeeData.bankPassbookImage.split("/").pop()
                  : employeeData.bankPassbookImage.name
                : "Click to upload a file"}
            </Typography>
          </Box>
        </Box>
      </Grid>

      </Grid>
    </MaterialBox>
  );
};

export default PFDetails;
